function __$styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

import { createElement, Component, PureComponent } from 'react';
import { number, func, bool, arrayOf, shape, object, string } from 'prop-types';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

__$styleInject("._rl-pagination-base_1i57z_1 {\n  display: flex;\n  justify-content: center;\n  list-style-type: none;\n}\n\n._rl-pagination_1i57z_1 {\n  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif,\n    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\n._rl-page-link-base_1i57z_15,\n._rl-page-link-base_1i57z_15:hover {\n  text-decoration: none;\n}\n._rl-page-link-base--active_1i57z_19 {\n  cursor: default;\n}\n._rl-page-link-base--disabled_1i57z_22 {\n  pointer-events: none;\n  cursor: default;\n}\n._rl-page-link_1i57z_15 {\n  padding: 0.2rem 0.5rem;\n  color: #135bb9;\n  margin: 0 5px;\n}\n._rl-page-link--active_1i57z_31 {\n  background-color: #dee2e6;\n  border-radius: 15%;\n  color: #444444;\n}\n._rl-page-link_1i57z_15:hover {\n  color: #6688b6;\n}\n\n._rl-page-link--disable_1i57z_40 {\n  color: #6c757d;\n}\n", {});
var styles = {"rlPaginationBase":"_rl-pagination-base_1i57z_1","rlPagination":"_rl-pagination_1i57z_1","rlPageLinkBase":"_rl-page-link-base_1i57z_15","rlPageLinkBaseActive":"_rl-page-link-base--active_1i57z_19","rlPageLinkBaseDisabled":"_rl-page-link-base--disabled_1i57z_22","rlPageLink":"_rl-page-link_1i57z_15","rlPageLinkActive":"_rl-page-link--active_1i57z_31","rlPageLinkDisable":"_rl-page-link--disable_1i57z_40"};

var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setPage = function (event, page) {
            if (event) {
                event.preventDefault();
            }
            if (!_this.props.isDisabled && !_this.props.isActive) {
                _this.props.onPageChange(page);
            }
        };
        return _this;
    }
    Page.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, page = _b.page, isActive = _b.isActive, isDisabled = _b.isDisabled, useBootstrapClasses = _b.useBootstrapClasses;
        var _c = this.props.classes, pageItem = _c.pageItem, pageLink = _c.pageLink, pageLinkActive = _c.pageLinkActive, pageLinkDisabled = _c.pageLinkDisabled;
        var customStyles = this.props.styles;
        var pageLinkStyles = __assign({}, customStyles.pageLink, (isActive ? customStyles.pageLinkActive : {}), (isDisabled ? customStyles.pageLinkDisabled : {}), (useBootstrapClasses && { boxShadow: 'none' }));
        return (createElement("li", { className: classnames(useBootstrapClasses && {
                'page-item': true,
                active: isActive,
                disabled: isDisabled
            }, [pageItem]), style: customStyles.pageItem },
            createElement("a", { href: "#", className: classnames(styles.rlPageLinkBase, pageLink, !useBootstrapClasses
                    ? (_a = {},
                        _a[styles.rlPageLinkBaseActive] = isActive,
                        _a[styles.rlPageLinkBaseDisabled] = isDisabled,
                        _a[pageLink || styles.rlPageLink] = true,
                        _a[pageLinkActive || styles.rlPageLinkActive] = isActive,
                        _a[pageLinkDisabled || styles.rlPageLinkDisable] = isDisabled,
                        _a) : 'page-link'), style: pageLinkStyles, onClick: function (event) { return _this.setPage(event, page); } }, this.props.children || page)));
    };
    Page.defaultProps = {
        classes: {},
        styles: {}
    };
    Page.propTypes = {
        isActive: bool,
        isDisabled: bool.isRequired,
        page: number.isRequired,
        onPageChange: func.isRequired
    };
    return Page;
}(PureComponent));

var Paginator = /** @class */ (function (_super) {
    __extends(Paginator, _super);
    function Paginator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Paginator.prototype.render = function () {
        var _a = this.props, currentPage = _a.currentPage, totalPages = _a.totalPages, pagesToShow = _a.pagesToShow, onPageChange = _a.onPageChange, useBootstrapClasses = _a.useBootstrapClasses, customStyles = _a.styles, classes = _a.classes, navigation = _a.navigation;
        var isFirstPage = currentPage === 1, isLastPage = currentPage === totalPages;
        var pageProps = {
            styles: customStyles,
            classes: classes,
            onPageChange: onPageChange,
            useBootstrapClasses: useBootstrapClasses
        };
        return (createElement("nav", { "aria-label": "Page navigation", style: customStyles.container, className: classnames({ paginator: useBootstrapClasses }, classes.container) },
            createElement("ul", { style: customStyles.list, className: classnames([styles.rlPaginationBase], { paginaton: useBootstrapClasses }, [classes.list || styles.rlPagination]) },
                !navigation.hideFirstPageNav && (createElement(Page, __assign({ page: 1, isDisabled: isFirstPage }, pageProps),
                    createElement("span", null, navigation.firstPageText || 'First'))),
                !navigation.hidePrevPageNav && (createElement(Page, __assign({ page: currentPage - 1, isDisabled: isFirstPage }, pageProps),
                    createElement("span", null, navigation.prevPageText || '←'))),
                pagesToShow.map(function (page, index) { return (createElement(Page, __assign({ key: index, isDisabled: false, isActive: page === currentPage, page: page }, pageProps))); }),
                !navigation.hideNextPageNav && (createElement(Page, __assign({ page: currentPage + 1, isDisabled: isLastPage }, pageProps),
                    createElement("span", null, navigation.nextPageText || '→'))),
                !navigation.hideLastPageNav && (createElement(Page, __assign({ page: totalPages, isDisabled: isLastPage }, pageProps),
                    createElement("span", null, navigation.lastPageText || 'Last'))))));
    };
    Paginator.propTypes = {
        currentPage: number.isRequired,
        totalPages: number.isRequired,
        pagesToShow: arrayOf(number).isRequired,
        onPageChange: func.isRequired
    };
    Paginator.defaultProps = {
        classes: {},
        styles: {},
        navigation: {}
    };
    return Paginator;
}(PureComponent));

var PaginatorService = /** @class */ (function () {
    function PaginatorService() {
    }
    PaginatorService.createRange = function (start, end) {
        var total = end - start + 1;
        if (total <= 0)
            return [];
        return Array(total)
            .fill(start)
            .map(function (value, index) { return value + index; });
    };
    PaginatorService.prototype.getPaginator = function (_a) {
        var totalItems = _a.totalItems, itemsPerPage = _a.itemsPerPage, maxPagesToShow = _a.maxPagesToShow, currentPage = _a.currentPage;
        var totalPages = PaginatorService.calculateTotalPages(totalItems, itemsPerPage);
        var pagesBeforeCurrent = Math.floor(maxPagesToShow / 2);
        // determine start and end pages to show
        var startPage = Math.max(currentPage - pagesBeforeCurrent, 1);
        var endPage = startPage + maxPagesToShow - 1;
        // shift to the left if there are no more pages left in the end
        if (endPage > totalPages) {
            var extraPages = endPage - totalPages;
            startPage = Math.max(startPage - extraPages, 1);
            endPage = totalPages;
        }
        // create array of pages to show
        var pagesToShow = PaginatorService.createRange(startPage, endPage);
        return { currentPage: currentPage, totalPages: totalPages, pagesToShow: pagesToShow };
    };
    PaginatorService.calculateTotalPages = function (totalItems, itemsPerPage) {
        return Math.ceil(totalItems / itemsPerPage);
    };
    return PaginatorService;
}());
var PaginatorService$1 = new PaginatorService();

var CustomPropTypes = {
    styles: shape({
        container: object,
        list: object,
        pageItem: object,
        pageLinkActive: object,
        pageLinkDisabled: object,
        pageLink: object
    }),
    classes: shape({
        container: string,
        list: string,
        pageItem: string,
        pageLinkActive: string,
        pageLinkDisabled: string,
        pageLink: string
    }),
    navigation: shape({
        firstPageText: string,
        prevPageText: string,
        nextPageText: string,
        lastPageText: string,
        hideFirstPageNav: bool,
        hidePrevPageNav: bool,
        hideNextPageNav: bool,
        hideLastPageNav: bool
    })
};

/**
 * @class PaginatorContainer
 */
var PaginatorContainer = /** @class */ (function (_super) {
    __extends(PaginatorContainer, _super);
    function PaginatorContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaginatorContainer.prototype.render = function () {
        var _a = this.props, currentPage = _a.currentPage, itemsPerPage = _a.itemsPerPage, maxPagesToShow = _a.maxPagesToShow, totalItems = _a.totalItems, rest = __rest(_a, ["currentPage", "itemsPerPage", "maxPagesToShow", "totalItems"]);
        var paginator = PaginatorService$1.getPaginator({
            totalItems: totalItems,
            currentPage: currentPage,
            itemsPerPage: itemsPerPage,
            maxPagesToShow: maxPagesToShow
        });
        return createElement(Paginator, __assign({}, paginator, rest));
    };
    PaginatorContainer.defaultProps = {
        currentPage: 1,
        itemsPerPage: 10,
        maxPagesToShow: 3,
        useBootstrapClasses: false,
        styles: {},
        classes: {},
        navigation: {}
    };
    PaginatorContainer.propTypes = {
        totalItems: number.isRequired,
        currentPage: number,
        onPageChange: func.isRequired,
        itemsPerPage: number,
        maxPagesToShow: number,
        useBootstrapClasses: bool,
        styles: CustomPropTypes.styles,
        classes: CustomPropTypes.classes,
        navigation: CustomPropTypes.navigation
    };
    return PaginatorContainer;
}(Component));

export default PaginatorContainer;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 1
// module chunks = 0